import React from 'react'

import { useTranslation } from 'react-i18next'
import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const MinimumTermOfLease: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
  wrapperClassName = 'grid-item',
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <Stepper
        id='minimum-term-of-lease'
        propertyName='minimumTermOfLease'
        placeholder={t('wizard.screen.otherFacilities.minimumTermOfLeasePlaceholder', 'Month(s)')}
        label='wizard.screen.otherFacilities.minimumTermOfLease'
        input={insertionData.minimumTermOfLease}
        type='tel'
        maxLength={4}
        max={999}
        errors={validationMessages!.minimumTermOfLease ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default MinimumTermOfLease
